import BaseListagem from "components/BaseListagem";
import Produto from "model/administracao/cadastro/produto/Produto";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ExecucaoPlanoQualidadeService from "service/qualidade/ExecucaoPlanoQualidadeService";
import QualidadeProdutoAcabadoService from "service/qualidade/QualidadeProdutoAcabadoService";
import { converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions, dateFilterTemplate, dateRangeFilterTemplate, decimalFilterTemplate, filterApplyTemplate, numberFilterTemplate, statusFilterTemplate } from "utils/filterUtils";

const produtoAcabadoService = new QualidadeProdutoAcabadoService();
const execucaoPlanoQualidadeService = new ExecucaoPlanoQualidadeService();

export default function QualidadeProdutoAcabadoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Produto Acabado');

    const [produtos, setProdutos] = useState<Produto[]>([]);

    useEffect(() => {
        produtoAcabadoService.getProdutos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        numero: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        produtoNome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        lote: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidade: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracao: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem 
            ordenacao="numero,DESC" 
            service={produtoAcabadoService} urlService="/qualidade/produtoAcabado" 
            tituloPagina={titulo} 
            showRemoveButton={false} showNewButton={false} 
            defaultFilters={defaultFilters} showClearFilterButton
            nome="produtoAcabado"
        >
            <Column field="numero" header="Número da OP" filter showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="produto.codigo" header="Produto" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />
            <Column field="produto.nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterField="produtoNome" />
            <Column field="lote" header="Lote" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="qtProduzida" header="Quantidade" filter showFilterOperator={false} showAddButton={false} filterElement={decimalFilterTemplate}
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterField="quantidade"/>
            <Column field="execucaoPlanoQualidade.dataGeracao" header="Geração" body={(rowData)=> converterDataHora(rowData?.dataGeracao) }  filter showFilterOperator={false} showAddButton={false}
                    showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterElement={dateRangeFilterTemplate} filterMenuStyle={{zIndex: 50}} filterField="dataGeracao"/>
            <Column field="execucaoPlanoQualidade.status" header="Status" body={(rowData)=> execucaoPlanoQualidadeService.getStatusLabel(rowData?.execucaoPlanoQualidade?.status||"")} filter showFilterOperator={false} showAddButton={false} filterMatchModeOptions={ListMatchModeOptions} filterField="status"
                    filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, execucaoPlanoQualidadeService.getListaStatusFilter())} />
        </BaseListagem>
    )
}